import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getFailedImportRows = createAsyncThunk('jobs/getFailedImportRows',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/jobs/failed-import-rows',
        {
          params
        });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getFailedImportRows;
